import React, { useState } from "react";
import IconButton from "./IconButton";
import HomeIcon from "./Icons/HomeIcon";
import NextStepsIcon from "./Icons/NextStepsIcon";
import ProposalBigIcon from "./Icons/ProposalBigIcon";

import GreyCard from "../GreyRectangles/GreyCard";
import NextStepsCardInfo from "../GreyRectangles/NextStepsCardInfo";
import "./Resume.css";
import InfoCard3 from "../GreyRectangles/InfoCard3";

import { SpecificBooking } from "../../../../types/responseTypes";
import BaseStatisticsCard from "../GreyRectangles/BaseStatisticsCard";

type TabType = "inicio" | "proximosPasos";

interface ResumeBarPreSignedProps {
  //specificBooking?: SpecificBooking | null;
  specificBooking: SpecificBooking;
}

const ResumeBarPreSigned: React.FC<ResumeBarPreSignedProps> = ({
  specificBooking,
}) => {
  
  const [activeTab, setActiveTab] = useState<TabType>("inicio");
  const handleSetActiveTab = (tab: TabType) => { setActiveTab(tab) };

  const [nextStepsChecks] = useState({
    propuesta: false,
    validacion: false,
    instalacion: false,
    papeleo: false,
  });

  const linkToPropuesta = `https://ruuf.cl/proposal/booking/${specificBooking.bookingId}`;

  const openLink = (link: string | undefined) => {
    if (link) {
      const formattedLink = link;//encodeURI(link);
      window.open(formattedLink, "_blank");
    }
  };

  return (
    <div>
      <div className="ResumeBar">
        <IconButton
          label="Inicio"
          icon={<HomeIcon />}
          isActive={activeTab === "inicio"}
          onClick={() => handleSetActiveTab("inicio")}
        />
        <IconButton
          label="Próximos Pasos"
          icon={<NextStepsIcon />}
          isActive={activeTab === "proximosPasos"}
          onClick={() => handleSetActiveTab("proximosPasos")}
        />
      </div>

      <div>
        {/* Contenido que cambia según el estado */}
        {activeTab === "inicio" && (
          <div className="justify-center">

            <BaseStatisticsCard specificBooking={specificBooking} />

            <InfoCard3
              logo={<ProposalBigIcon />}
              title="Propuesta"
              subtitle="Avísanos si quieres continuar!"
              buttonText="Revisar"
              onButtonClick={() => openLink(linkToPropuesta)}
            />
          </div>
        )}
        {activeTab === "proximosPasos" && (
          <div>
            <GreyCard>
              <NextStepsCardInfo
                title="Propuesta"
                //esta solucion esta malisima pero nada mas me funciona
                subtitle="Con datos sobre tu casa, techo y consumo, generamos tu propuesta final. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
                showCheckMark={nextStepsChecks.propuesta}
              />
            </GreyCard>
            <GreyCard>
              <NextStepsCardInfo
                title="Validación"
                subtitle="Debemos validar la información que nos entregaste y luego podrás comprar tu sistema solar."
                showCheckMark={nextStepsChecks.validacion}
                days="1-3 días"
              />
            </GreyCard>
            <GreyCard>
              <NextStepsCardInfo
                title="Instalación"
                subtitle="Coordinamos una visita inicial y luego la fecha para hacer la instalación de tus paneles solares."
                showCheckMark={nextStepsChecks.instalacion}
                days="5 días"
              />
            </GreyCard>
            <GreyCard>
              <NextStepsCardInfo
                title="Papeleo"
                subtitle="Posteriormente hay harto tramite invisible que hacemos para que tus paneles queden funcionando."
                showCheckMark={nextStepsChecks.papeleo}
                days="1-2 meses"
              />
            </GreyCard>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResumeBarPreSigned;
